module.exports = __webpack_public_path__ + "static/img/postiLetto.0bc252b.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/rooms/postiLetto.png
// module id = 9tOx
// module chunks = 1